export default __webpack_public_path__ + "f891c36dbea6e843653f6695dbf036b8.svg";